module.exports = __webpack_public_path__ + "static/media/step_one_bill.60983345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/steps/step_one_bill.png
// module id = 1412
// module chunks = 0